import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Column } from 'primereact/column';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import { ProgramMetadata } from '../../api/types/programs/program-metadata';
import { ProgramStatus } from '../../api/types/programs/program-status';
import { Tag } from 'primereact/tag';
import '../../component/styles/react-prime-custom-syle.css';
import { observer } from 'mobx-react-lite';
import './bread-crumbs-style.css';
import { ProgramsSideBar } from './side-bar/programs-side-bar';
import { ProgramsSideBarDatamodel } from './side-bar/programs-side-bar-datamodel';
import { getProgramsOperations } from './operations/get-programs-operations';
import { ReportProgramResponseType } from '../../api/types/reports/education/programms/report-program-response.type';
import { TableColumnLongTextWithInformation } from '../../component/table-componenets/cusom-column/table-column-long-text-with-information';
import { getHebrewYear } from '../../utils/hebrew-date-utils';

export enum ProgramFilterKeys {
  ProgramName = 'programName',
  StartYear = 'startYear',
  EndYear = 'endYear',
  // Add other filter keys as needed
}

const ProgramsPage = observer(() => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ReportProgramResponseType[]>([]);

  const navigate = useNavigate();

  const onCall = async (index: number) => {
    const selectedProgram = data[index];
    if (!loading && selectedProgram) {
      setLoading(true);
      try {
        navigate(
          `/campuses/${selectedProgram.branchId}/programs/${selectedProgram.programId}`,
        );
      } catch (e) {
        toast.error('טעינת הקורס נכשלה, נסה שוב');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOnSearch = async (filters: ProgramsSideBarDatamodel) =>
    await getProgramsOperations(filters, setLoading, setData);

  return (
    <div
      style={{
        width: '100%',
        marginTop: '16px',
      }}
    >
      <div
        style={{
          color: '#041E49',
          fontSize: '22px',
          fontWeight: 'bold',
          marginTop: '20px',
        }}
      >
        תוכניות הלימודים
      </div>

      <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <div>
          <ProgramsSideBar onSearch={handleOnSearch} />
        </div>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו תוכניות</div>
          }
          scrollHeight="100%"
          onRowClick={(event: DataTableRowClickEvent) => {
            onCall(event.index);
          }}
          style={{ width: '100%', height: 'calc(100vh - 140px)' }}
          selectionMode={'multiple'}
          multiple={true}
          groupRowsBy="dsf"
          value={data}
          scrollable
          onSelectionChange={(e) => {
            //setSelectedUsers(e.value as UserSummaryType[]);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
          }}
        >
          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שם"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ProgramMetadata) => (
              <div>{rowData.programName}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="מגמה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <div>
                {rowData.majors.map((item) => item.majorName).join(', ')}
              </div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שנת התחלה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ProgramMetadata) => (
              <div>
                {getHebrewYear(rowData.programStartYear)} (
                {rowData.programStartYear + 1} - {rowData.programStartYear})
              </div>
            )}
          />

          {/*          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שנת סיום"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <div>{rowData.programEndYear}</div>
            )}
          />*/}

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שנות לימוד"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <div>{rowData.abstractProgramYears}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="שלוחה"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <div>{rowData.branchName}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="מזהה שנתי"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <div>{Number(rowData.annualSerialProgramNumber) + 1}</div>
            )}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="סטטוס"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => {
              switch (rowData.programStatus) {
                case ProgramStatus.ACTIVE:
                  return (
                    <Tag
                      style={{ width: '50px' }}
                      severity={'secondary'}
                      value={'פעיל'}
                    />
                  );
                case ProgramStatus.INIT:
                  return (
                    <Tag
                      style={{ width: '50px' }}
                      className={'neutral-tag'}
                      value={'אותחל'}
                      severity={'secondary'}
                    />
                  );
                case ProgramStatus.CLOSE:
                  return (
                    <Tag
                      style={{ width: '50px' }}
                      severity={'danger'}
                      value={'נסגר'}
                    />
                  );
                case ProgramStatus.FINISHED:
                  return (
                    <Tag
                      style={{ width: '50px' }}
                      severity={'success'}
                      value={'סיים'}
                    />
                  );
              }
            }}
          />

          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="שלוחה"
            header="הערות התוכנית"
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(rowData: ReportProgramResponseType) => (
              <TableColumnLongTextWithInformation
                text={rowData.notes}
                uniqueId={rowData.programId}
                maxLength={8}
              />
            )}
          />
        </DataTable>
      </div>
    </div>
  );
});

export default ProgramsPage;
